module.exports = __webpack_public_path__ + "images/mobile/img-empty-request-6ae75c86fefc3d9f3f77494714e1ceab.png";